import { render } from "./cpt-radio-option-base.vue?vue&type=template&id=6a723e56"
import script from "./cpt-radio-option-base.vue?vue&type=script&lang=js"
export * from "./cpt-radio-option-base.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__